"use client";

import { useSyncExternalStore } from "react";

const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

function getReducedMotionSnapshot() {
  return window?.matchMedia?.(REDUCED_MOTION_QUERY)?.matches ?? false;
}

function getReducedMotionServerSnapshot() {
  return false;
}

function subscribeToReducedMotion(onStoreChange: () => void) {
  const mediaQuery = window?.matchMedia?.(REDUCED_MOTION_QUERY);
  if (!mediaQuery) {
    return () => {};
  }
  mediaQuery.addEventListener("change", onStoreChange);
  return () => mediaQuery.removeEventListener("change", onStoreChange);
}

function usePrefersReducedMotion() {
  return useSyncExternalStore(
    subscribeToReducedMotion,
    getReducedMotionSnapshot,
    getReducedMotionServerSnapshot,
  );
}

export { usePrefersReducedMotion };
